import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import axios from "axios";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";
import { languageHelper } from "../../config/helperFunctions";

function SignupPage({ logo, webSetting }) {
  const customer = localStorage.getItem("rms-customer");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    phone: "",
  });

  const navigate = useNavigate();

  const isEmail = webSetting?.signup_email === "active";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`${apiKey}/api/rms/customer/register`, formData)
      .then((res) => {
        toast.success(languageHelper("Success"), {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        if (isEmail) {
          navigate(`/otp?email=${formData.email}`);
        } else {
          localStorage.setItem("rms-customer", JSON.stringify(res.data.data));
          navigate("/");
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message || languageHelper("Something went wrong"), {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    if (customer) {
      navigate("/");
    }
  }, [customer, navigate]);

  return (
    <>
      <div className="grid place-items-center max-w-7xl mx-auto w-[90%] min-h-[80vh] px-4 py-16">
        <div className="max-w-2xl w-full">
          <div className="text-w-heading">
            <img className="mx-auto w-56" src={logo} alt="" />
            <h1 className="text-xl font-medium text-center mt-4">
              {languageHelper("Create an Account")}
            </h1>
          </div>
          <form onSubmit={handleSubmit} className="w-full max-w-sm mx-auto">
            <div className="mt-5 mx-auto w-full">
              <input
                className="border rounded w-full h-9 px-2"
                type="text"
                placeholder={languageHelper("Name")}
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="mt-5 mx-auto w-full">
              <PhoneInput
                defaultCountry="sa"
                className="border rounded w-full"
                inputClassName="w-full"
                placeholder={languageHelper("Enter your number")}
                name="phone"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e })}
              />
            </div>
            <div className="mt-5 mx-auto w-full">
              <input
                className="border rounded w-full h-9 px-2"
                type="email"
                placeholder={languageHelper("Email")}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="flex mt-5 w-full border rounded">
              <input
                className="h-9 px-2 w-full"
                type={!showPassword ? "password" : "text"}
                placeholder={languageHelper("Password")}
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="px-2"
                onClick={() => setShowPassword(!showPassword)}
              >
                {!showPassword ? (
                  <FaEye className="text-[#584869]" />
                ) : (
                  <FaEyeSlash className="text-[#584869]" />
                )}
              </button>
            </div>
            <div className="flex mt-5 w-full border rounded">
              <input
                className="h-9 px-2 w-full"
                type={!showConfirmPassword ? "password" : "text"}
                placeholder={languageHelper("Confirm Password")}
                name="password_confirmation"
                value={formData.password_confirmation}
                onChange={handleChange}
              />
              <button
                type="button"
                className="px-2"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {!showConfirmPassword ? (
                  <FaEye className="text-[#584869]" />
                ) : (
                  <FaEyeSlash className="text-[#584869]" />
                )}
              </button>
            </div>
            <div className="w-full flex gap-2 items-center mt-2">
              <label className="toggle-switch">
                <input type="checkbox" />
                <div className="toggle-switch-background">
                  <div className="toggle-switch-handle"></div>
                </div>
              </label>
              <p className="text-xs text-w-bg">
                {languageHelper("I accept the")}{" "}
                <Link className="text-gray-400 hover:underline">
                  {languageHelper("Terms of Service")}
                </Link>{" "}
                {languageHelper("and")}{" "}
                <Link className="text-gray-400 hover:underline">
                  {languageHelper("Privacy Policy")}
                </Link>
                .
              </p>
            </div>
            <div className="w-full mt-8 flex">
              <button
                type="submit"
                className="bg-w-btn text-w-btn-text max-w-[12rem] w-full px-2 py-1 rounded mx-auto text-center"
              >
                {languageHelper("SignUp")}
              </button>
            </div>
          </form>
          <div className="mt-24 w-full">
            <p className="text-center text-sm font-medium">
              {languageHelper("Already have an account?")}
              <Link to={"/login"} className="text-w-bg hover:underline ml-1">
                {languageHelper("Login")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignupPage;
